import { render, staticRenderFns } from "./MultiSearchHead.vue?vue&type=template&id=6afada7c"
import script from "./MultiSearchHead.vue?vue&type=script&lang=js"
export * from "./MultiSearchHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports